import React from 'react';
import { InfoContainer } from '@/app/common/designSystemTypedComponents.ts';
import { useToggle } from 'react-use';
import { useTranslation } from '@/app/components/translations/Translation';
import { IconBus } from '@/app/common/icons/libraryIcons';
import { css } from 'styled-components';

const DistanceToHotelIcon = () => (
  <IconBus
    css={css`
      font-size: ${({ theme }) => theme.commons.font.sizes.xlarge};
    `}
  />
);

export default function AirportInDifferentIslandMessage() {
  const { t } = useTranslation();
  const [isVisible, hide] = useToggle(true);

  if (!isVisible) return null;

  const keys = {
    title: 'vacation.select.details.differentisland.title',
    description: 'vacation.select.details.differentisland.description',
  };

  return (
    <InfoContainer
      icon={DistanceToHotelIcon}
      title={t(keys.title)}
      message={t(keys.description)}
      onClose={hide}
      type="specific"
      hasBorder={true}
    />
  );
}
